import { useEffect, useState } from "react";
import { TableRow, TableCell } from "@mui/material";
import { base64ToBlob } from "../../../utils/fileConvertorToBlob";
import { DocumentTypeEnum } from "../../../interfaces/mortgageDetailsInterface";

interface DocumentRowProps {
  files: {
    filename: string;
    type: string;
    data: string;
  };
}

export const DocumentRow = ({ files }: DocumentRowProps) => {
  const [objectURL, setObjectURL] = useState<string | null>(null);
  const getDisplayValue = <T,>(
    mapping: Record<string, T>,
    value: T
  ): string => {
    const entry = Object.entries(mapping).find(
      ([_, enumValue]) => enumValue === value
    );
    return entry && entry.length > 0 ? entry[0] : "N/A";
  };

  useEffect(() => {
    if (files.data) {
      const matches = files.data.match(/^data:(.+);base64,(.+)$/);
      if (matches && matches.length === 3) {
        const contentType = matches[1];
        const base64Data = matches[2];
        const blob = base64ToBlob(base64Data, contentType);
        const url = URL.createObjectURL(blob);
        setObjectURL(url);
        return () => {
          URL.revokeObjectURL(url);
        };
      }
    }
    return undefined;
  }, [files.data]);

  return (
    <TableRow>
      <TableCell>{files.filename || "N/A"}</TableCell>
      <TableCell>
        {files.type ? getDisplayValue(DocumentTypeEnum, files.type) : "N/A"}
      </TableCell>
      <TableCell>
        {objectURL ? (
          <a
            href={objectURL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#1976d2" }}
          >
            View Document
          </a>
        ) : (
          "No Data Available"
        )}
      </TableCell>
    </TableRow>
  );
};
